export default "__VITE_ASSET__CxfGy22s__"